<div class="d-flex flex-column">
  <div *ngIf="proposal.proposalInformation.riskDescriptionFreeText" class="d-flex proposal-details-row">
    <div class="pre-wrap">{{proposal.proposalInformation.riskDescriptionFreeText}}</div>
  </div>
</div>
